import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import StaffMembeForm from "./components/form";
import StaffMembeTable from "./components/table";
import Service from "../../services/memberService";
import DateRangePicker from "../../components/common/dateRangePicker";
import Search from "../../components/common/search";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateStaffMembe extends Component {
  state = {
    infoData: [],
    info: { sUrl: "" },
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
  };
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { staffMemberStatus } = params;
    this.setState({ loader: true, staffMemberStatus }, function () {
      this.callApiInfo();
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { staffMemberStatus } = params;
    if (this.state.staffMemberStatus !== staffMemberStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          staffMemberStatus: staffMemberStatus,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const {
      staffMemberStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;
    Service.fetchStaffMembersInfo(
      undefined,
      staffMemberStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response?.data?.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.members,
          totalRecords: totalRecords,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
        });
      }
    });
    this.setState({ loader: false });
  };

  addStaffMembeForm = (data) => {
    const { isEdit, info, imageUrl } = this.state;
    this.setState({ loader: true });
    console.log({ subStaffMembe: info.subStaffMembe });
    data["imageUrl"] = imageUrl;
    data["subStaffMembe"] = info.subStaffMembe;
    data["staffMembeId"] = isEdit ? info._id : undefined;
    var method = isEdit ? "PUT" : "POST";
    Service.addStaffMembeInfo(data, method).then((response) => {
      if (!response.error) {
        this.callApiInfo();
        // this.props.history.push("/dealer/inbox");
      }
      // //console.log("response", response[0] === "{");
      // toast.success("List fetched successfully!");
      // if (response[0] === "{") {
      //   this.setState({ infoData: [JSON.parse(response)] });
      // } else if (response[0] === "[") {
      //   this.setState({ infoData: JSON.parse(response) });
      // } else {
      //   this.setState({ infoData: [] });
      // }
    });
  };

  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };

  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        // if (searchText && searchText !== "" && searchText.length > 0) {
        $.ajaxQ.abortAll();
        this.callApiInfo();
        // }
      }
    );
  };

  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };

  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeActive = (staffMembeId, value, index) => {
    console.log({ staffMembeId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    Service.onStaffMembeReady(staffMembeId, value).then((response) => {
      if (!response.error) {
        infoData[index].active = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      staffMemberStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      searchText,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;
    const staffMembeFormProps = {
      info: info || {},
      imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      active: this.state.active,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeStaffMembeId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addStaffMembeForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      onChangeSubStaffMembe: (subStaffMembe) => {
        // var subStaffMembe1 = [];
        // for (let i = 0; i < subStaffMembe.length; i++) {
        //   subStaffMembe1.push(subStaffMembe[i]["label"]);
        // }
        for (let i = 0; i < subStaffMembe.length; i++) {
          subStaffMembe[i]["customOption"] = undefined;
        }
        info.subStaffMembe = subStaffMembe;
        this.setState({ info });
      },
      // StaffMembeForm: infoData,
    };
    const propsTable = {
      staffMemberStatus: staffMemberStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditInfo: (index, info) => {
        this.props.history.push("/staff-members/" + info._id + "/update");
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    const propsSearchText = {
      searchText: this.state.searchText,
      onChangeText: (searchText) => {
        this.onSearchText(searchText);
      },
    };
    return (
      <Fragment>
        <Breadcrumb title={staffMemberStatus} parent="StaffMembe" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react" style={{padding:"30px"}}>
                  <div className="row m-b-10">
                    <div className="col-sm-4">
                      <Button
                        className="btn btn-danger"
                        onClick={() =>
                          this.props.history.push("/staff-members/add")
                        }
                      >
                        Add New Staff Member
                      </Button>{" "}
                    </div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      <Search {...propsSearchText} />
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <StaffMembeTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalFormShow}
          toggle={() => this.onClickToggle()}
          size="lg"
        // style={{ width: "80%", maxWidth: "90%" }}
        >
          <ModalHeader toggle={() => this.onClickToggle()}>
            {isEdit ? "Update StaffMembe info" : "Add StaffMembe"}
          </ModalHeader>
          <ModalBody>
            <StaffMembeForm {...staffMembeFormProps} />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default CreateStaffMembe;
